import AiPeopleFlowWrongInformationList from 'modules/analytics/components/AiPeopleFlowWrongInformationList/AiPeopleFlowWrongInformationList';
import AiServicedList from 'modules/analytics/components/AiServicedList/AiServicedList';
import BimServicedList from 'modules/analytics/components/BimServicedList/BimServicedList';
import useAiActivityListData from 'modules/analytics/hooks/useAiActivityListData';
import useAiPeopleFlowListData from 'modules/analytics/hooks/useAiPeopleFlowListData';
import useBimActivityListData from 'modules/analytics/hooks/useBimActivityListData';
import { PageHeading, PageTemplate } from 'modules/shared/features/content';

const AiPeopleFlowPage = () => {
    const { data: logs, isLoading } = useAiPeopleFlowListData();

    // return (
    //     <PageTemplate>
    //         <PageHeading className="flex justify-between items-center">
    //             <div>AI People Flow</div>
    //         </PageHeading>

    //         <div>
    //             <AiPeopleFlowWrongInformationList isLoading={isLoading} AiPeoplFlow={logs} />
    //         </div>
    //     </PageTemplate>
    // );s

    return (
        <div>
            <AiPeopleFlowWrongInformationList isLoading={isLoading} AiPeoplFlow={logs} />
        </div>
    );
};

export default AiPeopleFlowPage;
